import { i18n } from 'src/boot/i18n'
import { Dialog } from 'quasar'

import MlServiceWorkerDialog from 'components/blocks/dialog/MlServiceWorkerDialog.vue'
import MlConfirmationDialog from 'components/blocks/dialog/MlConfirmationDialog.vue'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type onConfirm = (...args: any[] | any) => any

export type ConfirmationDialogOptions = {
  text?: string
  title?: string
  onConfirm?: onConfirm
  dataCy?: {
    confirm?: string
  }
}

export default class Dialoger {
  static serviceWorkerRefreshDialog() {
    return Dialog.create({
      component: MlServiceWorkerDialog,
      componentProps: {
        title: i18n.global.t('service_worker.updated.title'),
        content: i18n.global.t('service_worker.updated.content'),
        buttonText: i18n.global.t('service_worker.updated.refresh'),
        persistent: true,
      },
    }).onOk(() => {
      location.reload()
    })
  }

  static confirmationDialog(options?: ConfirmationDialogOptions) {
    return Dialog.create({
      component: MlConfirmationDialog,
      componentProps: {
        title: options?.title ?? i18n.global.t('dialog_confirmation.title'),
        text: options?.text,
        onConfirm: options?.onConfirm,
        dataCy: options?.dataCy,
      },
    })
  }
}
